module.exports = __webpack_public_path__ + "img/platform3.26c28382.png";